import { API_BASE } from "./api";
import { apiPost } from "./api";

const STORAGE_KEY = "n8nvibes_referral_code";

export function getStoredReferralCode(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function storeReferralCode(code: string): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, code);
  } catch {
    // sessionStorage unavailable
  }
}

export function clearStoredReferralCode(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // sessionStorage unavailable
  }
}

export interface AffiliatePublicProfile {
  name: string;
  photoUrl: string | null;
  bio: string | null;
}

export async function lookupAffiliateByCode(code: string): Promise<AffiliatePublicProfile | null> {
  try {
    const res = await fetch(`${API_BASE}/api/affiliate/public/${encodeURIComponent(code)}`);
    if (!res.ok) return null;
    const json = await res.json() as { success: boolean; data?: AffiliatePublicProfile };
    return json.success ? json.data ?? null : null;
  } catch {
    return null;
  }
}

export async function confirmReferral(code: string | null): Promise<{ referredBy: string | null }> {
  return apiPost<{ referredBy: string | null }>("/api/referral/confirm", { referralCode: code });
}
